import React, { Component } from "react"
import { Redirect } from "react-router-dom"
import helper from "../../../utils/helper"
import axios from "axios"
import config from "../../../utils/config"
import auth from "../../../utils/auth"
import ReactLoading from 'react-loading'
import { Modal, ModalHeader, ModalBody, Badge } from 'reactstrap'

class ModalInformacoes extends Component {
    userInfo = auth.getUserInfo()
    header = { headers: { 'Authorization': 'Bearer ' + auth.getToken() } }

    state = {
        data: {},
        loading: true,
        statusModal: false,
        redirect: false,
        path: '',
        copyIcon: 'las la-clipboard',
        paginaCarregadaEm: "",
        erroCarregamento: false,
        enviandoResetChip: false
    }

    getData = () => {
        this.setState({ loading: true, erroCarregamento: false })

        axios.get(`${config.base_api_url + config.api_v2}/${this.userInfo.empresa}/equipamento/${this.props.idEquipamento}/status/`, this.header)
        .then(({ data }) => {
            const dataAtual = new Intl.DateTimeFormat('pt-BR', {
                dateStyle: 'short',
                timeStyle: 'short',
                timeZone: this.userInfo.timezone
            }).format(new Date());

            this.setState({ data: data, loading: false, paginaCarregadaEm: dataAtual })
        })
        .catch(() => this.setState({ loading: false, erroCarregamento: true }))
    }

    goMonitorado = (id_monitorado, nome_monitorado) => {
        const mensagem = `<span>Deseja acessar a tela de status do monitorado <strong>${nome_monitorado}</strong> ?</span>`
        helper.dispatchEvent("showAviso", {
            message: mensagem,
            callback: () => this.setState({ redirect: true, path: `status/${id_monitorado}` })
        })
    }

    toggleModal = (status) => {
        if(status) {
            this.getData()
        }

        this.setState({ statusModal: status })
    } 

    showBadge = (status) => {
        let message = status
        let color = "secondary"

        if(status === "online") {
            message = "Online"
            color = "success"
        }

        if(status === "offline") {
            message = "Offline"
            color = "danger"
        }

        return <Badge color={color}>{message}</Badge>
    }

    showMessageResetChip = () => {
        if (this.state.enviandoResetChip) return

        helper.dispatchEvent("showAviso", {
            message: "Deseja enviar uma solicitação de reset para o chip? O reset é realizado por um serviço externo.",
            callbackLabel: "Enviar solicitação",
            callbackLabelClose: "Cancelar",
            callback: () => this.resetChip()
        })
    }   

    resetChip = () => {
        if (this.state.enviandoResetChip) return
        this.setState({ enviandoResetChip: true })

        axios({
            method: "post",
            url: `${config.base_api_url + config.api_v2}/${this.userInfo.empresa}/equipamento/${this.props.idEquipamento}/status/`,
            headers: { 'Authorization': 'Bearer ' + auth.getToken() }
        })
        .then(({ data }) => {
            helper.dispatchEvent("showAviso", {
                callback: null,
                message: data?.status === true
                    ? "Solicitação de reset aceita pelo serviço do chip."
                    : "O serviço do chip não confirmou a solicitação de reset. Tente novamente."
            })
        })
        .catch((error) => {
            const detail = error.response?.data?.detail
            helper.dispatchEvent("showAviso", {
                callback: null,
                message: typeof detail === "string" && detail.trim()
                    ? detail.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
                    : "Não foi possível solicitar o reset do chip. Tente novamente."
            })
        })
        .finally(() => this.setState({ enviandoResetChip: false }))
    }

    copyToClipboard = async (data) => {
        try {
            await navigator.clipboard.writeText(data)
            this.setState({copyIcon: "las la-clipboard-check"})
            console.log('Texto copiado para a área de transferência')
            setTimeout(() => {
                this.setState({copyIcon: "las la-clipboard"})
            }, 2_000)
        } catch (err) {
            this.setState({copyIcon: "las la-times-circle"})
            setTimeout(() => {
                this.setState({copyIcon: "las la-clipboard"})
            }, 1_000)
            console.log('Falha ao copiar o texto', err)
        }
    }

    render() {
        const { data, loading, erroCarregamento, statusModal, redirect, path } = this.state
        const { ultima_comunicacao, consumo_chip, monitorados_vinculados} = data

        if(redirect) {
            return <Redirect to={path}/>
        }

        return (
            <>
                <Modal className="modal-lg" isOpen={statusModal} toggle={() => this.toggleModal(false)}>
                    <ModalHeader toggle={() => this.toggleModal(false)}>
                        <div>
                            { 
                                !loading && !erroCarregamento &&
                                    `Última Comunicação: ${ultima_comunicacao}` 
                            }
                        </div>
                        <div style={{
                            fontSize: "11px",
                            color: "#9c9c9cff"
                        }}>
                            {
                                !loading && !erroCarregamento &&
                                    `Página foi carregada em: ${this.state.paginaCarregadaEm}`
                            }
                        </div>
                    </ModalHeader>
                    <ModalBody>
                        {
                            loading ? 
                                <div className="d-flex justify-content-center align-items-center" style={{ height: '50px' }}>
                                    <ReactLoading 
                                        className={(loading) ? "hdv-report-loading" : "hdv-noshow-item"} 
                                        type="spin" 
                                        color="var(--background-menu)"
                                        width={30} 
                                    />
                                </div>
                            : erroCarregamento ?
                                <div className="d-flex flex-col align-items-center" style={{ gap: '10px', padding: '20px' }}>
                                    <span>Não foi possível carregar as informações do equipamento.</span>
                                    <button className="hdv-btn-forms hdv-btn-blue" onClick={this.getData}>Tentar novamente</button>
                                </div>
                            :
                                <div className="d-flex flex-col" style={{ gap: '15px', width: '100%' }}>
                                    {   
                                        consumo_chip.status && (
                                            <details open className='custom-summary' style={{ width: '100%' }}>
                                                { 
                                                    consumo_chip.sim_card 
                                                        ?
                                                        <summary>
                                                            Chip/SimCard: {consumo_chip.sim_card} 
                                                            <i class={this.state.copyIcon} onClick={() => this.copyToClipboard(consumo_chip.sim_card)}></i>
                                                        </summary>
                                                        :
                                                        <summary>Chip</summary>

                                                }

                                                <div style={{ padding: '20px' }}>
                                                    {consumo_chip.status_ativo === 'falhou' ?
                                                        <div>Não foi possível consultar o consumo do chip no serviço externo.</div>
                                                    :
                                                    <div className="d-flex" style={{ gap: '10px'}}>
                                                        <div
                                                            className="d-flex flex-col justify-content-start"
                                                            style={{
                                                                border: '1.5px solid rgba(0, 0, 0, 0.100)',
                                                                padding: '10px',
                                                                background: 'white',
                                                                width: 'calc(100% / 3)',
                                                                gap: '10px',
                                                                borderRadius: '5px'
                                                            }}
                                                        >
                                                            <div className="d-flex align-items-center justify-content-between" style={{ width: "100%" }}>
                                                                <span style={{ color: "#979797", fontWeight: 'bold' }}>Consumo (MB)</span>
                                                                {this.showBadge(consumo_chip.status_ativo)}
                                                            </div>
                                                            <div className="d-flex align-items-end" style={{ width: "100%", gap: "10px", fontWeight: "bold" }}>
                                                                <progress min={0} max={consumo_chip.total} value={consumo_chip.consumo}/>
                                                                <span>{consumo_chip.porcentagem_consumo}</span>
                                                            </div>
                                                        </div>

                                                        <div
                                                            className="d-flex flex-col justify-content-start"
                                                            style={{
                                                                border: '1.5px solid rgba(0, 0, 0, 0.100)',
                                                                padding: '10px',
                                                                background: 'white',
                                                                width: 'calc(100% / 3)',
                                                                gap: '10px',
                                                                borderRadius: '5px'
                                                            }}
                                                        >
                                                            <span style={{ color: "#979797", fontWeight: 'bold' }}>Disponível (MB)</span>
                                                            <span style={{ fontSize: '18px', fontWeight: 'bold' }}>{consumo_chip.livre} / {consumo_chip.total}</span>
                                                        </div>

                                                        <div
                                                            className="d-flex flex-col justify-content-start"
                                                            style={{
                                                                border: '1.5px solid rgba(0, 0, 0, 0.100)',
                                                                padding: '10px',
                                                                background: 'white',
                                                                width: 'calc(100% / 3)',
                                                                gap: '10px',
                                                                borderRadius: '5px'
                                                            }}
                                                        >
                                                            <span style={{ color: "#979797", fontWeight: 'bold' }}>Último Evento no Chip</span>
                                                            <span style={{ fontSize: '18px', fontWeight: 'bold' }}>{consumo_chip.ultimo_evento}</span>
                                                        </div>
                                                    </div>
                                                    }

                                                    <div className="d-flex justify-content-end" style={{ width: "100%", marginTop: "20px" }}>
                                                        <button className="hdv-btn-forms hdv-btn m-0 w-100" style={{backgroundColor: "var(--background-menu)", color: "var(--fonte_menu_lateral)"}} onClick={this.showMessageResetChip} disabled={this.state.enviandoResetChip}>{this.state.enviandoResetChip ? "Enviando solicitação..." : "Solicitar reset do chip"}</button>
                                                    </div>
                                                </div>
                                            </details>
                                        )
                                    }

                                    <details open className='custom-summary' style={{ width: '100%' }}>
                                        <summary>Monitorados Vinculados</summary>
                                            <div className="d-flex flex-col align-items-center" style={{ padding: "20px", gap: "10px" }}>
                                                {
                                                    monitorados_vinculados.length === 0 ? 
                                                        <span>Nenhum monitorado vinculado</span>
                                                    : 
                                                        monitorados_vinculados.map((monitorado, keyMonitorado) => (
                                                            <div 
                                                                key={keyMonitorado} 
                                                                onClick={() => this.goMonitorado(monitorado.id, monitorado.nome)}
                                                                style={{ 
                                                                    padding: "10px", 
                                                                    backgroundColor: "var(--background-menu)", 
                                                                    color: "var(--fonte_menu_lateral)", 
                                                                    fontWeight: "bold", 
                                                                    borderRadius: "5px",
                                                                    width: "100%",
                                                                    cursor: 'pointer'
                                                                }}>
                                                                    <div className="label-monitorado">
                                                                        {monitorado.nome}
                                                                    </div>
                                                            </div>
                                                        ))
                                                }
                                            </div>
                                    </details>
                                </div>
                        }
                    </ModalBody>
                </Modal>

                <div style={{ textAlign: 'center' }}>
                    <i style={{ cursor: 'pointer', fontSize: '20px' }} className="fa fa-info" onClick={() => this.toggleModal(true)}></i>
                </div>
            </>
        )
    }
}

export default ModalInformacoes
